module.exports = __webpack_public_path__ + "static/media/MLH.03bbf56e.PNG";


//////////////////
// WEBPACK FOOTER
// ./public/maxsizeimages/books/MLH.PNG
// module id = 1769
// module chunks = 1